import classNames from 'classnames'

import type { ReactElement } from 'react'

import AppLogo from '~/components/AppLogo'

import './styles.scss'

interface Props {
  appLogoUrl: string
  rank: number
}

const IconRanking = ({ appLogoUrl, rank }: Props): ReactElement => {
  const rankingClasses = classNames('ranking-pin', {
    first: rank === 1,
    hundreds: rank > 100,
    second: rank === 2,
    third: rank === 3,
  })

  return (
    <div className="icon-ranking-component">
      <AppLogo appLogoUrl={appLogoUrl} size="small" />
      <div className={rankingClasses}>{rank}</div>
    </div>
  )
}

export default IconRanking
